import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

interface MemoryGraphParams {
  ownerId: string;
  seedMemoryId?: string;
  depth?: number;
  pathLimit?: number;
}

interface EntityGraphParams {
  ownerIdFilter?: string;
  pathLimit?: number;
  minConfidence?: number;
}

interface GraphStatsParams {
  ownerIdFilter?: string;
}

export const nimGraphKeys = {
  all: ['nim', 'graph'] as const,
  memory: (params: MemoryGraphParams) => [...nimGraphKeys.all, 'memory', params] as const,
  entity: (params: EntityGraphParams) => [...nimGraphKeys.all, 'entity', params] as const,
  stats: (params: GraphStatsParams) => [...nimGraphKeys.all, 'stats', params] as const,
};

export function useNimMemoryGraph(params: MemoryGraphParams, enabled = true) {
  return useQuery({
    queryKey: nimGraphKeys.memory(params),
    queryFn: () => adminClient.getNimMemoryGraph(params),
    enabled: enabled && Boolean(params.ownerId),
  });
}

export function useNimGraphStats(params: GraphStatsParams = {}) {
  return useQuery({
    queryKey: nimGraphKeys.stats(params),
    queryFn: () => adminClient.getNimGraphStats(params),
  });
}
